import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'index',
      meta: {
        title: 'navigation.home'
      },
      component: () => import('./views/index.vue')
    },
    // {
    //   path: '/compatible',
    //   name: 'compatible',
    //   meta: {
    //     title: 'navigation.compatible'
    //   },
    //   component: () => import('./views/compatible.vue')
    // },
    {
      path: '/question',
      name: 'question',
      meta: {
        title: 'navigation.question'
      },
      component: () => import('./views/question.vue')
    },
    {
      path: '/feedback',
      name: 'feedback',
      meta: {
        title: 'navigation.feedback'
      },
      component: () => import('./views/feedback.vue')
    },
    {
      path: '/product',
      name: 'product',
      meta: {
        title: 'navigation.product',
        hidden: true
      },
      component: () => import('./views/product/index.vue')
    },
    {
      path: '/course',
      name: 'course',
      meta: {
        title: 'navigation.course',
        hidden: true
      },
      component: () => import('./views/course.vue')
    },
    {
      path: '/opendots2TFcard',
      name: 'opendots2TFcard',
      meta: {
        title: 'navigation.course',
        hidden: true
      },
      component: () => import('./views/course-opendots2.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      meta: {
        title: 'navigation.privacyPolicy',
        hidden: true
      },
      component: () => import('./views/privacyPolicy.vue')
    },
    {
      path: '/terms-of-use',
      name: 'terms-of-use',
      meta: {
        title: 'navigation.termsOfUse',
        hidden: true
      },
      component: () => import('./views/termsOfUse.vue')
    }
  ],
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  // 路由跳转时滚动到页面顶部
  window.scrollTo(0, 0);
  next()
})

export default router